import * as Sentry from '@sentry/browser';
import { createDataService, createHttpService } from 'resift';
import getAuthToken from '@sift/resift/getAuthToken';

import config from 'config';
import { unauthorizedHandler } from 'store/dataServiceActionHandlers';

const http = createHttpService({
  getHeaders: () => ({
    Authorization: `Bearer ${getAuthToken()}`,
  }),
  prefix: `${config.API_ENV}/api`,
});

export default createDataService({
  services: { http },
  onError: err => {
    if (err.status === 401) {
      unauthorizedHandler();
      return;
    }

    Sentry.captureException(err);
    throw err;
  },
});
